import type { ApiClient } from './client';

// D219: the one public statistic — games this server hosted in the last week.
//
// `games` is OPTIONAL on purpose and absent below the server's floor. A client that
// forgets to branch therefore fails loudly (undefined) instead of quietly rendering
// "0 games played this week" on a front door, which is the one thing it must never say.

export interface ActivityStat {
  window: 'week';
  floor: number;
  games?: number;
  /** D221: people connected right now. Absent below its own floor, like `games`. */
  online?: number;
}

export class StatsApi {
  constructor(private readonly api: ApiClient) {}

  activity(): Promise<ActivityStat> {
    return this.api.get<ActivityStat>('/stats/activity');
  }
}
